<section class="seasons-page">
  <app-admin-page-header [title]="title" [subtitle]="subtitle">
    <div header-actions>
      <button class="admin-btn admin-btn--primary" (click)="createSeason()">Nova Temporada</button>
    </div>
  </app-admin-page-header>

  <div class="admin-feedback admin-feedback--error" *ngIf="feedbackError">
    {{ feedbackError }}
  </div>

  <div class="seasons-toolbar admin-surface">
    <input
      type="text"
      class="admin-input"
      [(ngModel)]="searchTerm"
      placeholder="Buscar por nome da temporada"
      (keydown.enter)="fetchSeasons()" />

    <select class="admin-input" [(ngModel)]="statusFilter">
      <option value="">Todos os status</option>
      <option value="UPCOMING">Próxima</option>
      <option value="ACTIVE">Ativa</option>
      <option value="FINISHED">Finalizada</option>
    </select>

    <div class="seasons-toolbar__actions">
      <button class="admin-btn admin-btn--primary" (click)="fetchSeasons()">Filtrar</button>
      <button class="admin-btn admin-btn--secondary" (click)="clearFilters()">Limpar</button>
    </div>
  </div>

  <div class="admin-surface seasons-table">
    <p-table [value]="seasons" [loading]="isLoading">
      <ng-template pTemplate="header">
        <tr>
          <th>ID</th>
          <th>Nome</th>
          <th>Status</th>
          <th>Período</th>
          <th>Passe</th>
          <th>Resumo</th>
          <th>Ações</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-season>
        <tr>
          <td>#{{ season.id }}</td>
          <td>{{ season.name }}</td>
          <td>{{ season.status }}</td>
          <td>
            {{ season.start_date | date : 'dd/MM/yyyy HH:mm' }} -
            {{ season.end_date | date : 'dd/MM/yyyy HH:mm' }}
          </td>
          <td>{{ season.has_battle_pass ? 'Sim' : 'Não' }}</td>
          <td>
            Rewards: {{ season.rewards_count }} | Missões: {{ season.missions_count }} | Níveis:
            {{ season.levels_count }} | BP Rewards: {{ season.pass_rewards_count }}
          </td>
          <td>
            <button class="admin-btn admin-btn--secondary" (click)="detailSeason(season.id)">
              Gerenciar
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
